module.exports = __webpack_public_path__ + "img/logo.2d2316c9.svg";